/*
 * @Author: Merlin
 * @Date: 2023-12-14 13:32:45
 * @LastEditors: Merlin
 * @LastEditTime: 2024-07-16 10:08:06
 * @Description: 
 */

// 下注按钮
const betButton = {
    'getting_the_bests': {
        en: 'GETTING THE BETS', 
        cn: '立即押注',
    },
    'nextRound': {
        en: 'Next Round', 
        cn: '下一回合',
    },
    'Cancel': {
        en: 'Cancel', 
        cn: '取消',
    },
    'Starting': {
        en: 'Starting', 
        cn: '将开始',
    },
    'FinishingBet': {
        en: 'Finishing Bet', 
        cn: '最后押注',
    },
    'CashedOut': {
        en: 'Cashed Out', 
        cn: '已提现',
    },

};

// ▼用于游戏 crash 
export const oCrashGame = {
    ...betButton,
    'startIn': {
        en: 'START IN', 
        cn: '即将开始于',
    },
    'go': {
        en: 'GO', 
        cn: '出发',
    },
    'NetworkStatus': {
        en: 'Network Status', 
        cn: '网络状态',
    },
    'History': {
        en: 'History', 
        cn: '游戏历史',
    },
    'jackpot01': {
        en: 'To win Jackpot you should place bets in Crash game. Players will start a race for collecting x80 000 sums of winning coefficients and the first who will reach those amount will get Jackpot. Example you win with 1.85 (you will get +0.85 to your total amount in Jackpot race). ', 
        cn: '要赢得Jackpot需在 Crash 游戏中押注以集得合計共 x80000 的获胜總倍率，並由第一个达到的玩家赢得Jackpot。若您以 1.85 倍获胜，将获得 Jackpot 总金额的 1.85倍。',
    },
    'jackpot02': {
        en: 'Percent of Jackpot winnings depends on the lowest bet amount and the distribution is represented below.', 
        cn: '可贏得的Jackpot百分比取决于最小押注，其分配如下：',
    },
    'ruleDesc01': {
        en: 'Place your bets and wait for the rocket to launch, click the "Cashout" button before the rocket explodes to receive the current multiplier!', 
        cn: '下注并等待火箭发射，在火箭爆炸前点击“返现”按钮以获得当前倍数的奖金。',
    },
    'ruleDesc02': {
        en: '', // mini 版中被废弃 
        cn: '',
    },
    'ruleAlert': {
        en: '⚠️ This game requires a stable internet connection!!!',
        cn: '⚠️ 这个游戏需要连接稳定的网络！！！',
    },
    'ruleText': {
        en: `
            ● The speed of response of the "Cashout" button and the display of the multiplier depends on the speed of the Internet.
            ● BetCorgi cannot guarantee that the "Cashout" button will respond instantly when operated by the player.
            ● We recommend that you set up an automatic Cashout stop.
        `.trim().replace(/ *\n */g, '\n'), 
        cn: `
            ● “返现”按钮的反应速度与是否显示倍率取决于网络速度，
            ● BetCorgi 无法保证玩家操作“返现”按钮时能够立即反应，
            ● 我们建议您设定自动止盈返现。
        `.trim().replace(/ *\n */g, '\n'), 
    },
};


